import { render, staticRenderFns } from "./InvitationSupport.vue?vue&type=template&id=00a0f805"
import script from "./InvitationSupport.vue?vue&type=script&lang=js"
export * from "./InvitationSupport.vue?vue&type=script&lang=js"
import style0 from "./InvitationSupport.vue?vue&type=style&index=0&id=00a0f805&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports